import React, { useState } from 'react';
import '../chat/Chat.css';

function CreateGroupModal({ allUsers, currentUserId, onClose, onCreate }) {
  const [name, setName]       = useState('');
  const [selected, setSelected] = useState(new Set());
  const [error, setError]     = useState('');
  const [saving, setSaving]   = useState(false);

  const toggle = (id) => {
    setSelected(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const handleCreate = async () => {
    if (!name.trim()) { setError('Group name required.'); return; }
    setSaving(true);
    setError('');
    try {
      await onCreate({ name: name.trim(), members: [...selected] });
      onClose();
    } catch (e) {
      setError(e.response?.data?.msg || 'Error creating group.');
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <h3>New Group</h3>
        <input
          className="form-input"
          placeholder="Group name"
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleCreate()}
          autoFocus
        />
        <div>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 4 }}>Members</div>
          <div className="member-list">
            {allUsers.filter(u => u._id !== currentUserId).map(u => (
              <label key={u._id} className="member-list-item">
                <input
                  type="checkbox"
                  checked={selected.has(u._id)}
                  onChange={() => toggle(u._id)}
                />
                <span className={`chat-sender role-${u.role}`}>{u.username}</span>
                <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{u.role}</span>
              </label>
            ))}
          </div>
        </div>
        {error && <div className="form-error">{error}</div>}
        <div className="modal-actions">
          <button className="btn-secondary" onClick={onClose} disabled={saving}>Cancel</button>
          <button className="btn-primary"   onClick={handleCreate} disabled={saving || !name.trim()}>
            {saving ? 'Creating…' : 'Create'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CreateGroupModal;
